export default __webpack_public_path__ + "static/migration-27a028eeba2ffdd7acfd01300c258e5d.svg";